export interface ContactPersonItemFormutil {
    first_name: string;
    middle_initial?: string;
    last_name: string;
    tel_code: string;
    phone: string;
    email: string;
    relationship: string;
    country: string;
    home_address: string;
    home_address2: string;
    home_city: string;
    home_state_code: string;
}

export interface TrustedContactPersonDataItem extends ContactPersonItemFormutil {
    id: number;
}

export interface TrustedContactPersonFormutil {
    temporaryContactPerson: TrustedContactPersonDataItem[];
}
